export default "__VITE_ASSET__0c8a99ea__"